import { writable } from "svelte/store";
import type { PublicConfig } from "@fooji/microsites";

export const initStore = () => writable<PublicConfig>();
export const configStore = initStore();
export const set = (config: PublicConfig) => configStore.set(config);
